import { render, staticRenderFns } from "./StatsFilter.vue?vue&type=template&id=5b70de64&lang=pug&"
import script from "./StatsFilter.vue?vue&type=script&lang=js&"
export * from "./StatsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports